import { Map, fromJS } from "immutable";
import * as type from "./actionTypes";

const init_state = Map({
  searchParam: "",
});

const reducer = (impersonation = init_state, action) => {
  switch (action.type) {
    case type.SET_TARGET_EMAIL:
      return impersonation.set("targetEmail", action.payload.targetEmail);
    case type.GET_MERCHANTS_START:
      return impersonation.set("isFetching", action.payload.isFetching);
    case type.SET_SEARCH_PARAM:
      return impersonation.set("searchParam", action.payload.searchParam);
    case type.GET_MERCHANTS_SUCCESS:
      return impersonation
        .set("isFetching", action.payload.isFetching)
        .set("merchants", fromJS(action.payload.merchants.data))
        .set("total", fromJS(action.payload.merchants.total))
        .set("origin", fromJS(action.payload.merchants.url));
    case type.GET_MERCHANT_DETAILS:
      return impersonation.set("merchantDetails", action.payload.merchant);
    case type.GET_USERS_START:
      return impersonation.set("isFetching", action.payload.isFetching);
    case type.GET_USERS_SUCCESS:
      return impersonation.set("users", action.payload.users).set("isFetching", action.payload.isFetching);
    case type.GET_USERS_ERROR:
      return impersonation.set("users", action.payload.users).set("isFetching", action.payload.isFetching);
    case type.GET_MERCHANT_SOURCE_SUCCESS:
      return impersonation.set("merchantSource", action.payload);
    default:
      return impersonation;
  }
};

export default reducer;
